
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Component({
    selector: 'que-generic-form-array',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: GenericFormArrayComponent,
            multi: true
        }
    ],
    imports: [CommonModule, MatButtonModule],
    templateUrl: './generic-form-array.component.html',
    styleUrls: ['./generic-form-array.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericFormArrayComponent<T = string> implements ControlValueAccessor {
  @Input() itemTemplate?: TemplateRef<any>;
  @Input() addBtnTemplate?: TemplateRef<any>;
  @Input() addDefaultItem?: T;
  // @Input() removeBtnTemplate?: TemplateRef<any>;
  valuesArray = this.fb.array([]);
  callBack: any;
  values$ = toSignal(this.valuesArray.valueChanges.pipe(map(x => this.valuesArray.controls) ))
  constructor(private readonly fb: FormBuilder) {
    this.valuesArray.valueChanges.subscribe(o => {
      if (this.callBack) {
        this.callBack(o);
      }
    })
    //await this.waitForNextCycle();
  }
  // waitForNextCycle(delay: number = 0) {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve(null);
  //     }, 5000);
  //   });
  // }
  writeValue(values: T[]): void {
    if (!values) {
      return;
    }
    this.valuesArray.clear( { emitEvent: false });
    // for (let index = 0; index < values.length; index++) {
    //   // this.add();
    // }
    
    // this.valuesArray.patchValue(values, { emitEvent: false });//????false
    values.forEach(x=>this.valuesArray.push(new FormControl<T>(x)))
  }

  registerOnChange(fn: (arr: T[]) => void): void {
    this.callBack = fn;
  }

  registerOnTouched(fn: any): void {

  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.valuesArray.disable();
    } else {
      this.valuesArray.enable();
    }
  }

  add(index?:number) {
    var x = this.addDefaultItem as T;
    if(index==undefined){
      this.valuesArray.push(new FormControl<T | null>(x));
    }else{
      this.valuesArray.insert(index+1,new FormControl<T | null>(x));
    }

  }

  remove(idx: number) {
    this.valuesArray.removeAt(idx);
  }

}